export const GETALL_ITEM_REQUEST = "GETALL_ITEM_REQUEST";
export const GETALL_ITEM_SUCCESS = "GETALL_ITEM_SUCCESS";
export const GETALL_ITEM_FAIL = "GETALL_ITEM_FAIL";

export const GETBYID_ITEM_REQUEST = "GETBYID_ITEM_REQUEST";
export const GETBYID_ITEM_SUCCESS = "GETBYID_ITEM_SUCCESS";
export const GETBYID_ITEM_FAIL = "GETBYID_ITEM_FAIL";

export const ADD_ITEM_REQUEST = 'ADD_ITEM_REQUEST';
export const ADD_ITEM_SUCCESS = 'ADD_ITEM_SUCCESS';
export const ADD_ITEM_FAIL = 'ADD_ITEM_FAIL';

export const UPDATE_ITEM_REQUEST = 'UPDATE_ITEM_REQUEST';
export const UPDATE_ITEM_SUCCESS = 'UPDATE_ITEM_SUCCESS';
export const UPDATE_ITEM_FAIL = 'UPDATE_ITEM_FAIL';

export const DELETE_ITEM_REQUEST = 'DELETE_ITEM_REQUEST';
export const DELETE_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS';   
export const DELETE_ITEM_FAIL = 'DELETE_ITEM_FAIL';
